module.exports = __webpack_public_path__ + "static/media/432_modalités_pratiques.95a0b6fb.svg";